import React from "react";
import { Link } from "react-router-dom";

const LOGO_URL =
    "https://www.magniflex.com/frontend_assets/b2c/media/img/logo/magniflex-official-logo-it_IT.png";

export default function SiteHeader({ rightSlot = null, sticky = true }) {
    return (
        <header
            data-testid="site-header"
            className={`${sticky ? "sticky top-0" : ""} z-40 w-full backdrop-blur-xl border-b border-magni-light`}
            style={{ background: "rgba(247,247,247,0.92)" }}
        >
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-24 flex items-center justify-between">
                <Link to="/" data-testid="header-logo-link" className="flex items-center gap-3">
                    <img
                        src={LOGO_URL}
                        alt="Magniflex"
                        className="h-10 sm:h-12 w-auto"
                    />
                    <div className="hidden md:flex flex-col leading-none pl-3 border-l border-magni-light">
                        <span className="overline">MagniStretch® Trial</span>
                    </div>
                </Link>
                <div className="flex items-center gap-3">{rightSlot}</div>
            </div>
        </header>
    );
}
